import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { MAIN_MAP } from '../../../../redux/map/Constants';
import { withStyles } from '@material-ui/core/styles';

class PreviewMapImage extends React.Component {
    constructor (props) {
        super(props);
        this._isMounted = false;
        this.newestDate = (new Date()).getMilliseconds();
    }

    render () {
        const { classes, mapImage, highlights } = this.props;
        return <div style={{ backgroundImage: `url('${mapImage}')` }} className={`${classes.root} ${this.props.className}`} ></div>;
    }
}

const styles = theme => ({
    root: {
        ['@media (max-width:1370px)']: {
            minWidth: '400px',
            minHeight: '300px'
        },
        ['@media (min-width:1371px)']: {
            minHeight: '600px',
            minWidth: '800px'
        },
        width: '100%',
        border: `1px solid ${theme.palette.grey.variant5}`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center'

    },
    loadingContainer: {
        border: `1px solid ${theme.palette.grey.variant5}`,
        ['@media (max-width:1370px)']: {
            minWidth: '460px',
            minHeight: '380px'
        },
        ['@media (min-width:1371px)']: {
            minHeight: '600px',
            minWidth: '800px'
        },
        display: 'grid',
        placeItems: 'center',
        backgroundColor: 'rgb(0, 0, 0, 0.2)'
    },
    loadingOverlay: {
        width: '100%',
        height: '100%'
    },
    loadingInner: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    loadingText: {
        paddingTop: '10px',
        color: theme.palette.primary.contrastText
    },
    loadingIcon: {
        '& > svg': {
            color: theme.palette.primary.light
        }
    }
});

const mapStateToProps = state => ({
    baseLayers: state.layers.baseLayers,
    layers: state.layers.layers,
    drawModule: state[MAIN_MAP].drawModule,
    highlights: state.highlights,
    map: state[MAIN_MAP]
});

const mapDispatchToProps = dispatch => ({

});

export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(PreviewMapImage);